import { select } from "@angular-redux/store";
import { Component, ElementRef, EventEmitter, Input, OnDestroy, OnInit, Output, ViewChild } from "@angular/core";
import { Observable } from "rxjs/Observable";
import { SharedActions } from "../../shared.actions";
import { DepotInActions } from "../../../depot-in/depot-in.actions";
import { DepotOutActions } from "../../../depot-out/depot-out.actions";
import { ComponentSource, ModalType } from "../../models/component-source";
import { CreateTransportOrder } from "../../models/transport-order/create-transport-order.interface";
import { TransportOrderPlanUnit } from "../../models/transport-order/transport-order-plan-unit.interface";
import { TransportOrderWithPlanUnit } from "../../models/transport-order/transport-order-with-plan-unit.interface";
import { SharedService } from "../../services/shared.service";
import { PoolService } from "../../../pool/pool.service";
import { LocationSelectorComponent } from "../../components/location-selector/location-selector.component";
import { AddressLocation } from "../../models/address-location";
import { ActionBarService } from "../../services/action-bar.service";
import { ModalManagerService } from "../../services/modal-manager.service";
import { PlanningBlock } from "../../../pb-screen/models/planning-block/planning-block.interface";
import { ApplicationUser } from "../../../pb-screen/models/application.user.interface";
import { CapacitySlot } from "../../models/capacity-slot.interface";
import { OrderLine } from "../../../pb-screen/models/order-line/orderLine.interface";
import { SmsService } from "../../services/sms.service";
import { PrintTicketService } from "../../services/print/printticket.service";
import { AuthorizedUser, HomeService } from "../../../pb-screen/services/home.service";
import { TarTasService } from "../../services/tartas.service";
import { TarTasManager } from "../../services/tartas-manager.service";
import { MsalService } from "../../../msal";
import { IdNameAsStringObject } from "../../../pb-screen/models/quick-view/id-name-as-string-object.interface";
import { ContainerStatusId } from "../../../pb-screen/models/planning-block/planning-block-container-status.interface";
import { Driver } from "../../../static/models/driver.interface";
import { SimpleModalComponent } from "ngx-simple-modal";
import { Subject } from "rxjs";


import * as moment from "moment";
import { takeUntil } from "rxjs/operators";
import { UserFeedbackService } from "../../../services/user-feedback.service";
import { TranslateService } from "@ngx-translate/core";
import { Sms } from "../../models/sms/sms.interface";
import { environment } from "../../../../environments/environment";
import { TransportOrder } from "../../models/transport-order/transport-order.interface";
import { Haulier } from "../../../pb-screen/models/haulier.interface";
import { PbScreenService } from "../../../pb-screen/services/pb-screen.service";
import { group } from "console";
import { ScreenAuthorization, UserAuthorization } from "../../../users-authorizations/models/user-authorization.interface";
import { UsersAuthorizationService } from "../../../users-authorizations/user-authorization.service";
import { CheckDateCompatabilityService } from "../../../services/planning-logic/check-date-compatability.service";
import { ConfirmDialogService } from "../../components/confirm-dialog/confirm-dialog.service";
import { UpdateContainerStatusModel } from "../../models/update-container-status-model.interface";
import { PlanningBoardFacade } from "../../../planningBoard/services/planning-board.facade";
import { DepotOptimisticPlanningService } from "../../../optimistic-planning/depot-optimistic-planning.service";
import { PlanningInput } from "../../services/planning-orchestration.service";


@Component({
  selector: "depot-planning-modal",
  templateUrl: "./depot-planning-modal.component.html",
})
export class DepotPlanningModalComponent extends SimpleModalComponent<DepotPlanningModalInput, boolean> implements OnInit, OnDestroy {
  public depotOutSelection: PlanningBlock[] = [];
  public depotInSelection: PlanningBlock[] = [];
  public selectedPlanningBlocks: PlanningBlock[];
  public filteredPlanningBlocks: PlanningBlock[];

  public selectedCapacity: CapacitySlot;
  public planDate: Date;
  public signalRUserChannel: string;
  public uiState: boolean[];
  public loading = false;
  public componentSource = ComponentSource;
  public modalType = ModalType;
  public sendDepotInSms: boolean = false;
  public sendDepotOutSms: boolean = false;
  public depotInSmsMessage: string = "";
  public depotOutSmsMessage: string = "";
  public selectedDriver: Driver;

  public statusEnabled = false;
  public selectedPbsStatus: string;
  public selectedStatus: IdNameAsStringObject;
  public statusOptions: IdNameAsStringObject[] = [];
  public containerStatuses: IdNameAsStringObject[] = [];
  public statusPlanningBlock: PlanningBlock;
  public containerNumberRequired: boolean = false;
  public buttonState: boolean = true;

  /** Swallows repeat clicks while a plan submission is in flight — a double-submit fires two
   *  concurrent BC writes on the same TO and trips BC's stale-record error. Released on paths
   *  that keep the modal open (reuse notice, plan errors); a safety timer covers validation
   *  early-returns; success closes the modal so the component is destroyed anyway. */
  public planSubmitInFlight = false;
  private planSubmitReleaseTimer: any = null;
  public locationFilled: boolean = true;
  public containerNumberFilled: boolean = false;
  public containerNumber: string;
  public depotInFrom: string;
  public depotInFromRequired: boolean = false;
  public containerStatusId = ContainerStatusId;
  public selectedLocation: AddressLocation;
  public containerNumberIsValid: boolean = true;
  public containerNumberErrorMessage: string;
  public newLocationSelection: boolean = false;
  public planAndSendSucceeded: boolean = false;
  public transportOrderNumber: string = "";
  public depotInPlanningBlockIdsForTextMessage: number[] = [];
  public depotOutPlanningBlockIdsForTextMessage: number[] = [];
  private userName: string = "";
  private userId: string = "";
  private CONTAINER_NUMBER_LENGTH: number = 11;
  private reuseNotified: boolean = false;
  public linkToAppointmentEnabled: boolean = false;
  public showWarning: boolean = false;
  public warningMessage: string = "";
  public planningFunctionCallback: Function = null;

  public planningDateNotCompatibleWarning: boolean = false;
  private applicationUser: ApplicationUser;
  destroy$ = new Subject();
  public disableToSelectionModal: boolean = false;
  public openTransportOrdersForCapacity: TransportOrder[] = [];
  public openTransportOrdersForHaulier: TransportOrder[] = [];
  public selectedTransportOrder: TransportOrder = null;
  public toRowIndex: number = null;
  public emptyCapacity: CapacitySlot;
  public selectedCs: any;
  public selectedHaulier: Haulier;
  public masterDetailView: boolean = false;




  @Output() public onPlanningSucceeded: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Input() public source: string;
  public PlanningSucceeded: Function;

  @select("depotOutSelection") public depotOutSelection$: Observable<PlanningBlock[]>;
  @select("depotInSelection") public depotInSelection$: Observable<PlanningBlock[]>;
  @select("applicationUser") public applicationUser$: Observable<ApplicationUser>;
  @select("filteredPlanningblocks") public filteredPlanningblocks$: Observable<PlanningBlock[]>;
  @select("uiState") public uiState$: Observable<boolean[]>;
  @select("containerStatuses") public containerStatuses$: Observable<IdNameAsStringObject[]>;
  @select("loading") public loading$: Observable<boolean>;

  @ViewChild(LocationSelectorComponent) private locationSelector: LocationSelectorComponent;

  public enableAutocomplete: boolean = false;
  containerIsAvailable: boolean = false;
  public locationRequired: boolean;

  // Flag to enable optimistic UI mode (can be controlled via environment or user settings)
  public useOptimisticPlanning: boolean = false;

  constructor(
    private readonly elementRef: ElementRef,
    public readonly pbScreenService: PbScreenService,
    private readonly sharedService: SharedService,
    private readonly translate: TranslateService,
    private readonly sharedActions: SharedActions,
    private readonly userFeedbackService: UserFeedbackService,
    private readonly printTicketService: PrintTicketService,
    private readonly depotInActions: DepotInActions,
    private readonly depotOutActions: DepotOutActions,
    private readonly smsService: SmsService,
    private readonly homeService: HomeService,
    private readonly poolService: PoolService,
    private readonly actionBarService: ActionBarService,
    private readonly modalManager: ModalManagerService,
    private readonly authService: MsalService,
    private readonly tarTasService: TarTasService,
    private readonly tarTasManager: TarTasManager,
    private readonly userAuthorizationSerivce: UsersAuthorizationService,
    private readonly checkDateCompatibilityService: CheckDateCompatabilityService,
    private readonly confirmDialogService: ConfirmDialogService,
    private readonly planningFacade: PlanningBoardFacade,
    private readonly depotOptimistic: DepotOptimisticPlanningService

  ) {
    super();
    // Depot optimistic mode follows the user's Depot setting (independent of the board flag).
    this.useOptimisticPlanning = this.depotOptimistic.isEnabled;
  }

  public ngOnInit() {
    this.loading$.subscribe((data) => {
      if (!data) {
        this.loading = data;
      }

    });
    this.applicationUser$.subscribe((user: ApplicationUser) => {  
      if(user)
      {
        this.applicationUser = user; 
        this.disableToSelectionModal = this.applicationUser.generalSetting.disableTOSelectionModal;

      }

    });
    this.userId = this.authService.getAccount().username;
    this.depotOutSelection$.pipe(takeUntil(this.destroy$)).subscribe((selectedPlanningBlocks: PlanningBlock[]) => {
      this.depotOutSelection = selectedPlanningBlocks;
      if (this.source === this.componentSource.depotOut) {
        this.selectedPlanningBlocks = selectedPlanningBlocks;
      }
      if (this.depotInSelection.length + this.depotOutSelection.length > 0) {
        this.initializeStatusOptions();
      }
      this.isLinkToAppointmentEnabled();
    });
    this.containerStatuses$.pipe(takeUntil(this.destroy$)).subscribe((statuses: IdNameAsStringObject[]) => {
      this.statusOptions = statuses;
      this.containerStatuses = statuses;
    });
    this.depotInSelection$.pipe(takeUntil(this.destroy$)).subscribe((selectedPlanningBlocks: PlanningBlock[]) => {
      this.depotInSelection = selectedPlanningBlocks;
      if (this.source === this.componentSource.depotIn) {
        this.selectedPlanningBlocks = selectedPlanningBlocks;
      }
      if (this.depotInSelection.length + this.depotOutSelection.length > 0) {
        this.initializeStatusOptions();
      }
      this.isLinkToAppointmentEnabled();
    });

    this.uiState$.subscribe((uiState: boolean[]) => {
      this.uiState = uiState;
    });
  }

  ngAfterViewInit () {
    if (this.depotInSelection.length + this.depotOutSelection.length > 0) {
      this.initializeStatusOptions();
    }

  }

  ngOnDestroy(): void {
    this.selectedTransportOrder = null;
    this.selectedCapacity = null;

    this.destroy$.next();
    this.destroy$.complete();
  }

  public initializeStatusOptions() {
    if (!this.depotInSelection.length && !this.depotOutSelection.length) {
      return;
    }
    this.statusPlanningBlock = this.depotInSelection.length > 0 ?
      this.depotInSelection[0] : this.depotOutSelection[0];
    this.selectedPbsStatus = this.statusPlanningBlock.containerStatus;
    this.selectedStatus = this.containerStatuses.find(el => el.name == this.selectedPbsStatus);
    this.setSelection();
    if (this.locationSelector) {
      this.locationSelector.setSelectionFromParent(this.statusPlanningBlock.latestLocationCode);
    }
    if (this.selectedStatus) {
      this.getValidStatuses(this.statusPlanningBlock.orderNumber);
    }
    this.statusEnabled =
      this.depotInSelection.every((x) => x.containerStatus === this.selectedStatus?.name) &&
      this.depotOutSelection.every((y) => y.containerStatus === this.selectedStatus?.name);
    this.depotInFrom = new Date().toISOString().slice(0, 10);

  }

  public locationsAreReady(){
    if (this.locationSelector) {
      this.locationSelector.setSelectionFromParent(this.statusPlanningBlock.latestLocationCode);
    }
  }

  public async closeModal() {
    await this.close();
    this.modalManager.closeModal(this.modalType.planning);
    this.clearFields();
  }

  public clearFields() {
    this.reuseNotified = false;
    this.depotInFromRequired = false;
    this.selectedCapacity = null;
    this.containerNumberIsValid = true;
    this.buttonState = true;
    this.depotInFrom = new Date().toISOString().slice(0, 10);
    this.initializeStatusOptions();
    this.containerNumber = this.statusPlanningBlock.containerNo;
    this.containerNumberFilled = this.containerNumber !== "" ? true : false;
    this.locationFilled = true;
    this.selectedStatus = this.containerStatuses.find(el => el.name == this.selectedPbsStatus);
    this.planAndSendSucceeded = false;
    this.transportOrderNumber = "";
    this.depotInPlanningBlockIdsForTextMessage = [];
    this.depotOutPlanningBlockIdsForTextMessage = [];
    this.selectedLocation = null;
    this.selectedTransportOrder = null;
    this.selectedCapacity = null;
    this.openTransportOrdersForCapacity = [];
    this.openTransportOrdersForHaulier = [];
    this.sharedActions.resetModalDomains();
    this.sharedActions.setUiState(true);
  }

  public getSelectedCapacity(capacity) {
    this.selectedCapacity = capacity;
    if (capacity) {
      this.selectedCapacity = capacity;
      const driverId = (capacity.driver && capacity.driver.id) ? capacity.driver.id.toString() : '';
      const truckId = (capacity.truck && capacity.truck.id) ? capacity.truck.id.toString() : '';

      if (!this.disableToSelectionModal && driverId && truckId && this.planDate && this.userAuthorizationSerivce.canAddPBToExistingTO()) {
        this.sharedService.getOpenTos(driverId, truckId, moment(this.planDate).toISOString()).subscribe((data) => {
          if (data)
            this.openTransportOrdersForCapacity = data;
          else
            this.openTransportOrdersForCapacity = [];
        })
      }
    }
  }

  public getSelectedPlanDate(planDate) {
    this.planDate = planDate;
    this.planningDateNotCompatibleWarning = false;
  }

  public onPlanAndSendAction(printAndSendSms: boolean) {
    let apiFormattedDate = moment(this.planDate).format("yyyy-MM-DD");

    let letPlanning: boolean = true;
    const planUnit: TransportOrderPlanUnit = {
      depotInPlanningBlocks: this.depotInSelection,
      depotOutPlanningBlocks: this.depotOutSelection,
    } as TransportOrderPlanUnit;

    const dataLoad: CreateTransportOrder = {
      capacitySlot: this.selectedCapacity,
      planDate: apiFormattedDate,
      planUnit,
    } as CreateTransportOrder;

    let datePlanningErrors = "" ; 
    if (planUnit.depotOutPlanningBlocks && planUnit.depotOutPlanningBlocks.length > 0) {

      planUnit.depotOutPlanningBlocks.forEach((pb) => { 
        if (this.comparePlanDateToDepotOutFrom(pb) == false ){
          datePlanningErrors +="Depot Out From date is not compatible with selected plan date for planning block - Order Number : " + pb.orderNumber + ".\n"; 
          letPlanning = false;
        } 

      } ); 
      
    }

    if (planUnit.depotInPlanningBlocks && planUnit.depotInPlanningBlocks.length > 0) {
      planUnit.depotInPlanningBlocks.forEach((pb) => {
        if (this.comparePlanDateToDepotInFrom(pb) == false) {
          datePlanningErrors += "Depot In From date is not compatible with selected plan date for planning block - Order Number: " + pb.orderNumber + ".\n";
          letPlanning = false;
        }

      }); 
    }
    if (this.selectedTransportOrder) { 
      this.planToExistingTransportOrders(dataLoad, printAndSendSms);
    } else {
      if (letPlanning) {
        // In optimistic mode the modal closes instantly, so skip the blocking spinner.
        // (Must mirror the optimistic gate in excutePlanningAction.)
        if (!(this.useOptimisticPlanning && !this.selectedTransportOrder)) {
          this.loading = true;
        }
        let selectedDriver = this.selectedDriver;
        if ((typeof selectedDriver === "string" || selectedDriver instanceof String)) // TODO:sometimes it just assign "" , we should check where that come from.
        {
          selectedDriver = undefined;
        } else if (!selectedDriver && this.selectedCapacity?.driver) {

        }

         if (this.selectedDriver || this.selectedCapacity?.driver) {
              this.sharedService.checkDriverAbsence(moment(this.planDate).startOf('day').format("yyyy-MM-DD"), this.selectedDriver == null ? this.selectedCapacity.driver.id : this.selectedDriver.id).subscribe(async (data) => {
                if (data.length > 0) {
                  this.translate.get(
                    "SHARED.DRIVER_ABSENT_ON_SELECTED_DATE",
                    {
                      driverName: this.selectedDriver == null ? this.selectedCapacity.driver.name : this.selectedDriver.name,
                      fromDate: this.prettifyDate(data[0].fromDate),
                      toDate: this.prettifyDate(data[0].toDate)
                    }
                  ).subscribe((driverAbsentMessage) => {
                    this.confirmDialogService.confirmThis(driverAbsentMessage, () => {
                      this.excutePlanningAction(dataLoad, selectedDriver, printAndSendSms);
                     }, () => { });
                  });
                }
                else {
                  this.excutePlanningAction(dataLoad, selectedDriver, printAndSendSms);

                }
              });
            }
            else {
              this.excutePlanningAction(dataLoad, selectedDriver, printAndSendSms);
            }
           
      } else {
        this.userFeedbackService.showErrorMessage(datePlanningErrors) ; 
      }
    }
  }

  /**
   * Execute planning with optimistic UI - instant feedback
   * 
   * This method:
   * 1. Creates optimistic TO/PBs immediately
   * 2. Closes the modal right away (user sees instant result)
   * 3. Backend processes async, updates via SignalR
   */
  private executeOptimisticPlanning(dataLoad: CreateTransportOrder, selectedDriver: Driver, printAndSendSms: boolean): void {
    // Feed the screen-agnostic optimistic engine so the affected depot rows lock + shimmer
    // instantly (and mirror across tabs). The background chain mirrors the button semantics:
    // plain Pre-plan runs prePlan ONLY (status stops at pre-planned); only the Send variant
    // finalizes with group + send (→ planned) — same distinction as the standard path.
    const input: PlanningInput = {
      depotInPlanningBlocks: dataLoad.planUnit.depotInPlanningBlocks,
      depotOutPlanningBlocks: dataLoad.planUnit.depotOutPlanningBlocks,
      capacitySlot: dataLoad.capacitySlot,
      planDate: new Date(dataLoad.planDate),
      userId: this.userId,
      selectedDriver,
      existingTransportOrder: (this.selectedTransportOrder as any) || undefined,
      statusUpdate: this.statusEnabled ? {
        enabled: true,
        status: this.selectedStatus?.name,
        location: this.selectedLocation
      } : undefined
    };

    this.depotOptimistic.planOptimistic(input, { finalize: printAndSendSms });

    // Show brief feedback and close modal immediately — user keeps working.
    this.userFeedbackService.showInfoMessage('SHARED.PLANNING_IN_PROGRESS');

    this.depotInActions.setDepotInSelection([]);
    this.depotOutActions.setDepotOutSelection([]);
    this.onPlanningSucceeded.emit(true);

    if (this.PlanningSucceeded) {
      this.PlanningSucceeded(true);
    }

    this.closeModal();
  }

  private excutePlanningAction(dataLoad: CreateTransportOrder, selectedDriver: Driver, printAndSendSms: boolean) {
    // Check if optimistic mode is enabled and conditions are met
    if (this.useOptimisticPlanning && !this.selectedTransportOrder) {
      // Optimistic flow for new TOs — both buttons. Pre-plan runs prePlan only (stops at
      // pre-planned); Pre-plan & Send finalizes with group + send (→ planned). The legacy
      // post-send extras (auto print-ticket, manual SMS) are intentionally skipped in
      // optimistic mode; with the setting OFF the standard path below is unchanged.
      this.executeOptimisticPlanning(dataLoad, selectedDriver, printAndSendSms);
      return;
    }

    // Standard flow for complex cases (existing TO, SMS, etc.)
    this.sharedService.prePlanAction(dataLoad.capacitySlot, dataLoad.planUnit, dataLoad.planDate, this.userId, selectedDriver).subscribe(
      (prePlannedData: TransportOrderWithPlanUnit) => {
        let planningBlocks: PlanningBlock[] = [];
        planningBlocks.push(...prePlannedData.planningBlocks.depotInPlanningBlocks);
        planningBlocks.push(...prePlannedData.planningBlocks.depotOutPlanningBlocks);
        this.updatePlanningBlocks(planningBlocks,this.userId).then((updateSuccesfull:boolean) => {
          if( !updateSuccesfull) {
            this.sharedActions.updatePlanningBlocksDisplayCpl([...prePlannedData.planningBlocks.depotInPlanningBlocks, ...prePlannedData.planningBlocks.depotOutPlanningBlocks]);
          }
        if (printAndSendSms) {
          this.groupAndSendPlanningBlocks(prePlannedData, dataLoad,  prePlannedData.transportOrder.id, printAndSendSms);
        } else {
          this.updateScreenAndShowMessage(prePlannedData.planningBlocks, prePlannedData.transportOrder?.id);
          this.closeModal().then(() => {
            this.depotInActions.setDepotInSelection([]);
            this.depotOutActions.setDepotOutSelection([]);
          });
        } } , (error) => {
          //this.onErrorRerollPreplan(dataLoad, error);
          this.sharedActions.updatePlanningBlocksDisplayCpl([...prePlannedData.planningBlocks.depotInPlanningBlocks, ...prePlannedData.planningBlocks.depotOutPlanningBlocks]);
          if (printAndSendSms) {
            this.groupAndSendPlanningBlocks(prePlannedData, dataLoad, prePlannedData.transportOrder.id, printAndSendSms);
          } else {
            this.updateScreenAndShowMessage(prePlannedData.planningBlocks, prePlannedData.transportOrder?.id);
            this.closeModal().then(() => {
              this.depotInActions.setDepotInSelection([]);
              this.depotOutActions.setDepotOutSelection([]);
            });
      }}); 
      },
      (error) => {
        this.onErrorRerollPreplan(dataLoad, error);
      });
  }

  private planToExistingTransportOrders(dataLoad: CreateTransportOrder, printAndSendSms: boolean) {
    let apiFormattedDate = moment(this.planDate).format("yyyy-MM-DD");

    if (this.selectedPlanningBlocks.length === 0) {
      this.selectedPlanningBlocks = [...this.depotInSelection, ...this.depotOutSelection];
    }
    if (this.checkDatesCompatiblity()) {
      this.planningDateNotCompatibleWarning = true;
      this.planningFunctionCallback = (confirmDateChange: boolean = false) => {
        this.loading = true;
        this.sharedService.planToExistingTos(this.selectedTransportOrder.id, [...dataLoad.planUnit.depotInPlanningBlocks, ...dataLoad.planUnit.depotOutPlanningBlocks], this.userId, confirmDateChange, apiFormattedDate).subscribe((prePlannedData: TransportOrderWithPlanUnit) => {
          this.sharedActions.updatePlanningBlocksDisplayCpl(prePlannedData.planningBlocks.depotInPlanningBlocks);
          this.sharedActions.updatePlanningBlocksDisplayCpl(prePlannedData.planningBlocks.depotOutPlanningBlocks);
          let planningBlocks: PlanningBlock[] = [];
          planningBlocks.push(...prePlannedData.planningBlocks.depotInPlanningBlocks);
          planningBlocks.push(...prePlannedData.planningBlocks.depotOutPlanningBlocks);
          this.updatePlanningBlocks(planningBlocks, this.userId).then(() => {
          this.groupAndSendPlanningBlocks(prePlannedData, dataLoad, prePlannedData.transportOrder.id, printAndSendSms);
        }, (err) => {
          this.userFeedbackService.showErrorMessage("TOASTR_MESSAGES.ERROR.PLAN_FAILED", err);
          this.onErrorRerollPreplan(dataLoad, err);
        })});
      };

    }
    else {
      this.loading = true;
      this.sharedService.planToExistingTos(this.selectedTransportOrder.id, [...dataLoad.planUnit.depotInPlanningBlocks, ...dataLoad.planUnit.depotOutPlanningBlocks], this.userId, true, apiFormattedDate).subscribe((prePlannedData: TransportOrderWithPlanUnit) => {
        this.sharedActions.updatePlanningBlocksDisplayCpl(prePlannedData.planningBlocks.depotInPlanningBlocks);
        this.sharedActions.updatePlanningBlocksDisplayCpl(prePlannedData.planningBlocks.depotOutPlanningBlocks);
        this.groupAndSendPlanningBlocks(prePlannedData, dataLoad, prePlannedData.transportOrder.id, printAndSendSms);
      }, (err) => {
        this.userFeedbackService.showErrorMessage("TOASTR_MESSAGES.ERROR.PLAN_FAILED", err);
        this.onErrorRerollPreplan(dataLoad, err);
      });
    }
  }

  public groupAndSendPlanningBlocks(prePlannedData: TransportOrderWithPlanUnit, dataLoad: CreateTransportOrder,
    transportOrderNumber: string, printAndSendSms: boolean) {
    this.sharedService.group(prePlannedData.planningBlocks, this.userId).subscribe(
      (groupedData: TransportOrderPlanUnit) => {
        this.sendPlanningBlocks(groupedData, dataLoad, transportOrderNumber, printAndSendSms);
      },
      (error) => {
        this.onErrorRerollPreplan(dataLoad, error);
      });
  }

  public sendPlanningBlocks(groupedData: TransportOrderPlanUnit, dataLoad: CreateTransportOrder,
    transportOrderNumber: string, printAndSendSms: boolean) {
    this.sharedService.send(groupedData, this.userId).subscribe(
      (planUnit: TransportOrderPlanUnit) => {

        this.sharedActions.updatePlanningBlocksDisplayCpl(planUnit.depotInPlanningBlocks) ; 
        this.sharedActions.updatePlanningBlocksDisplayCpl(planUnit.depotOutPlanningBlocks);

        if (environment.printTicketAfterPlanning) {
          this.printTicket(planUnit, transportOrderNumber);
        }
        if (printAndSendSms && validateConditionsForSendingSMS(groupedData, dataLoad)) {
          this.getTextMessageAfterSucceededPlan(transportOrderNumber,
            planUnit.depotInPlanningBlocks.map((x) => x.id),
            planUnit.depotOutPlanningBlocks.map((x) => x.id));
        } else {
          this.closeModal().then(() => {
            this.depotInActions.setDepotInSelection([]);
            this.depotOutActions.setDepotOutSelection([]);
            this.updateScreenAndShowMessage(planUnit, transportOrderNumber);
          });
        }
      },
      (error) => {
        this.onErrorRerollPreplan(dataLoad, error);
      });
  }

  updateScreenAndShowMessage(planUnit: TransportOrderPlanUnit, transportOrderNumber: string) {
    if (!transportOrderNumber) {
      transportOrderNumber = planUnit.depotInPlanningBlocks.concat(planUnit.depotOutPlanningBlocks).find(el => el.transportOrderNumber)?.transportOrderNumber ?? "";
    }

    this.loading = false;

    this.userFeedbackService.showSuccessMessage("TOASTR_MESSAGES.SUCCESS.PLAN_SUCCEEDED");
    this.onPlanningSucceeded.emit(true);
    if (this.PlanningSucceeded) {
      this.PlanningSucceeded(true);
    }
    this.locationSelector.locationchanged = false;
  }

  public printTicketTest(planUnit: TransportOrderPlanUnit, transportOrderNumber: string) {
    const pbIds = [1066236];
    const pbIdsIn = [1066236];
    const pbIdsOut = [];
    let pbsIn = [];
    let pbsOut = [];
    this.sharedService.getPlanningBlocksByIds(pbIdsIn).subscribe((pbsin: PlanningBlock[]) => {
      pbsIn = pbsin;
      this.sharedService.getPlanningBlocksByIds(pbIdsOut).subscribe((pbsout: PlanningBlock[]) => {
        pbsOut = pbsout;
        this.sharedService.getOrderLines(pbIds.join(",")).subscribe(
          (orderlines: OrderLine[]) => {
            const newUnit: TransportOrderPlanUnit = {
              depotInPlanningBlocks: pbsIn,
              depotOutPlanningBlocks: pbsOut,
            } as TransportOrderPlanUnit;

            this.printTicketService.printTicket(newUnit, "TO17-048915", orderlines, this.userName).subscribe();
          });
      });
    });

  }

  public printTicket(planUnit: TransportOrderPlanUnit, transportOrderNumber: string) {

    const pbIds = [...planUnit.depotInPlanningBlocks, ...planUnit.depotOutPlanningBlocks]
      .reduce((planningblockIds, pb) => {
        planningblockIds.push(pb.id);
        return planningblockIds;
      }, [])
      .join(",");

    this.sharedService.getOrderLines(pbIds).subscribe(
      (orderlines: OrderLine[]) => {
        this.printTicketService.printTicket(planUnit, transportOrderNumber, orderlines, this.userName)
          .subscribe(_ => {
          });
      });
  }

  public onErrorRerollPreplan(dataLoad: CreateTransportOrder, _) {
    this.sharedService.undoPreplan(dataLoad.planUnit, this.userId);
    this.loading = false;
    this.releasePlanSubmit();
    this.userFeedbackService.showErrorMessage("TOASTR_MESSAGES.ERROR.PLAN_FAILED");
  }

  public onErrorUndoSend(dataLoad: CreateTransportOrder, error) {
    this.sharedService.undoSend(dataLoad.planUnit, this.userId).subscribe((undoPlanData: TransportOrderPlanUnit) => {
      this.sharedService.undoPreplan(undoPlanData, this.userId);
      this.loading = false;
      this.releasePlanSubmit();
      this.userFeedbackService.showErrorMessage("TOASTR_MESSAGES.ERROR.PLAN_FAILED");
    });
  }

  public getValidStatuses(orderNo: string) {
    this.sharedService.getValidContainerStatuses(orderNo, this.selectedPbsStatus)
      .subscribe((data: string[]) => {
        if (this.statusPlanningBlock) {
          data.push(this.statusPlanningBlock.containerStatus);
          let array = this.containerStatuses.filter(status => data.find(el => el == status.name));
          this.statusOptions = array;
        }
      });
  }

  public selectionChanged() {
    this.setSelection();
    if (this.selectedStatus?.name === this.selectedPbsStatus) {
      this.locationFilled = true;
      this.containerNumberFilled = true;
      this.locationSelector.clearSelection();
      this.setButtonState();
    } else {
      if (this.locationSelector.selectedLocation
        && this.locationSelector.selectedLocation.searchName.length > 0) {
        this.locationFilled = true;
        this.setButtonState();
      } else {
        this.locationFilled = false;
        this.setButtonState();
      }
    }
    this.reuseNotified = false;
  }

  public setSelection() {
    switch (this.selectedStatus?.id) {
      case ContainerStatusId.leegCrea:
        this.containerNumberRequired = false;
        this.depotInFromRequired = false;
        break;
      case ContainerStatusId.leegAf:
        this.containerNumberRequired = true
          && (this.depotInSelection.length + this.depotOutSelection.length === 1);
        this.depotInFromRequired = false;
        if (this.depotInSelection.length + this.depotOutSelection.length === 1) {
          this.containerNumber = this.statusPlanningBlock.containerNo;
          this.onContainerInput(this.containerNumber);
        }
        break;
      case ContainerStatusId.geladen:
        this.containerNumberRequired = false;
        this.depotInFromRequired = false;
        break;
      case ContainerStatusId.volKlaar:
        this.containerNumberRequired = false;
        this.depotInFromRequired = false;
        break;
      case ContainerStatusId.volCrea:
        this.containerNumberRequired = false;
        this.depotInFromRequired = false;
        break;
      case ContainerStatusId.volAf:
        this.containerNumberRequired = false;
        this.depotInFromRequired = true;
        break;
      case ContainerStatusId.leegKlaar:
        this.containerNumberRequired = false;
        this.depotInFromRequired = false;
        break;
      case ContainerStatusId.volIn:
        this.containerNumberRequired = false;
        this.depotInFromRequired = false;
        break;
      case ContainerStatusId.gelost:
        this.containerNumberRequired = false;
        this.depotInFromRequired = false;
        break;
      default:
        this.containerNumberRequired = false;
        this.depotInFromRequired = false;
    }

    this.setButtonState();
  }

  public setButtonState() {
    if (!this.containerNumberRequired) {
      this.containerNumberFilled = true;
    }
    if (!this.containerNumberFilled || (!this.locationFilled && this.locationRequired)) {
      this.buttonState = false;
    } else {
      this.buttonState = true;
    }
  }

  public async updateAndPlan(printAndSendSms: boolean) {
    if (this.planSubmitInFlight) return;
    this.lockPlanSubmit();

    const isReusable = await this.actionBarService.isReuseable(this.depotInSelection, this.depotOutSelection,
      this.source, this.selectedStatus, this.statusEnabled);

    if ((isReusable && this.reuseNotified) || !isReusable) {
      if (this.containerNumberRequired) {
        this.checkContainerNumber(printAndSendSms);
      } else {
        this.updateData(false, printAndSendSms);
      }
    } else if (isReusable && !this.reuseNotified) {
      this.notifyReuse();
      this.releasePlanSubmit();
    }
  }

  private lockPlanSubmit(): void {
    this.planSubmitInFlight = true;
    clearTimeout(this.planSubmitReleaseTimer);
    this.planSubmitReleaseTimer = setTimeout(() => this.planSubmitInFlight = false, 8000);
  }

  private releasePlanSubmit(): void {
    this.planSubmitInFlight = false;
    clearTimeout(this.planSubmitReleaseTimer);
  }

  public sendSms() {
    const account = this.authService.getAccount();
    this.userId = account.username;
    if (account.username) {
      this.smsService.send(this.transportOrderNumber,
        this.depotInPlanningBlockIdsForTextMessage,
        this.depotOutPlanningBlockIdsForTextMessage,
        this.depotInSmsMessage,
        this.depotOutSmsMessage,
        account.username,
      ).subscribe(() => {
        this.closeModal();
        this.userFeedbackService.showSuccessMessage("TOASTR_MESSAGES.SUCCESS.REQUEST_SMS_SUCCESS");
      }, _ => {
        this.closeModal();
      });
    } else {
      this.closeModal();
    }
  }

  onContainerInput(input: string) {
    if (this.selectedPlanningBlocks.length !== 0 && this.selectedPlanningBlocks[0].containerNo !== input
      && input.length === this.CONTAINER_NUMBER_LENGTH) {
      this.sharedService.checkContainerNumbersInFile(this.selectedPlanningBlocks[0].fileId, input).subscribe((res: boolean) => {
        if (!res) {
          this.userFeedbackService.showWarningMessage(
            "STATUS_MODAL.FILE_ALREADY_CONTAINS_CONTAINER_NUMBER",
            {
              fileId: this.selectedPlanningBlocks[0].fileId,
              containerNumber: input
            }
          );
        }
      });
    }
    if (this.containerNumber && this.containerNumber.length > 0 && (/\S/.test(input))) {
      this.containerNumberFilled = true;
      this.setButtonState();
    } else {
      this.containerNumberFilled = false;
      this.setButtonState();
    }
  }

  private checkContainerNumber(printAndSendSms: boolean) {
    this.sharedService.checkContainerNumberCpl(this.containerNumber, this.userId).subscribe((res) => {
      if (res.statusCode === 200) {
        this.containerNumberIsValid = true;
        const statusPlanningBlock = this.depotInSelection.length > 0 ?
          this.depotInSelection[0] : this.depotOutSelection[0];
        if (statusPlanningBlock.containerNo !== this.containerNumber) {
          this.checkContainerAvailability(statusPlanningBlock.id, this.containerNumber, printAndSendSms);
        } else {
          this.updateData(false, printAndSendSms);
        }
      }
    },
      (err) => {
        const description = err.feedback[0].description;
        this.containerNumberIsValid = false;
        this.buttonState = false;
        this.containerIsAvailable = false;
        this.translate.get("STATUS_MODAL.ERROR_PANEL.ERROR_TEXT").subscribe((res: string) => {
          this.containerNumberErrorMessage = description + " " + res.split(":")[1];
        });
      });
  }

  checkContainerAvailability(PbId: number, containerNumber: string, printAndSendSms: boolean) {
    this.containerNumberIsValid = true;
    const statusPlanningBlock = this.depotInSelection.length > 0 ?
      this.depotInSelection[0] : this.depotOutSelection[0];

    this.poolService.checkContainerAvailability(statusPlanningBlock.id, this.containerNumber, this.userId)
      .subscribe((available: boolean) => {
        if (available) {
          this.containerIsAvailable = true;
        } else {
          // false: the user can carry on the normal function (update or plan)
          this.buttonState = true;
          this.updateData(false, printAndSendSms);
        }
      }, (err) => {
        // display error , the user will have to type another c number
        this.buttonState = false;
        this.containerIsAvailable = false;
      });
  }

  moveContainerOutOfPool(printAndSendSms: boolean) {
    const statusPlanningBlock = this.depotInSelection.length > 0 ?
      this.depotInSelection[0] : this.depotOutSelection[0];

    this.poolService.registerApprovePoolContReqChecks([statusPlanningBlock.id], this.userId).subscribe(() => {
      this.updateData(true, printAndSendSms);
    }, (err) => {
      // display error , the user will have to type another c number
      this.buttonState = true;
      this.containerIsAvailable = false;
    });
  }

  getSelectedLocation(location: AddressLocation) {
    if (location) {
      this.selectedLocation = location;
      if (this.locationSelector.selectedLocation
        && this.locationSelector.selectedLocation.searchName.length > 0) {
        this.locationFilled = true;
        this.setButtonState();
      } else {
        this.locationFilled = false;
        this.setButtonState();
      }
    } else {
      this.locationSelector.setSelectionFromParent("empty");
    }
  }

  resetContainerNumber() {
    this.containerNumber = null;
    this.containerNumberIsValid = true;
    this.containerNumberFilled = false;
    this.containerIsAvailable = false;
    this.buttonState = false;
  }

  private async updateData(isMoveContainerOutOfPool: boolean, printAndSendSms: boolean) {
    const promises = [];
    const account = this.authService.getAccount();
    this.userId = account.username;

    this.depotInSelection.forEach((planningBlock: PlanningBlock) => {
      promises.push(this.updateFields(planningBlock, isMoveContainerOutOfPool, account.username));
    });

    this.depotOutSelection.forEach((planningBlock: PlanningBlock) => {
      promises.push(this.updateFields(planningBlock, isMoveContainerOutOfPool, account.username));
    });

    Promise.all(promises).then(() => {
        this.onPlanAndSendAction(printAndSendSms);
    });
  }

 

  private async updateFields(
    planningBlock: PlanningBlock,
    isMoveContainerOutOfPool: boolean,
    userId: string
  ): Promise<void> {
    await this.updateDepotInDate(planningBlock, userId);
    await this.updateContainerNumber(planningBlock, isMoveContainerOutOfPool);
  }

  private updateDepotInDate(planningBlock: PlanningBlock, userId: string): Promise<boolean> {
    const scope = this;
    return new Promise<boolean>((resolve) => {
      if (!scope.depotInFromRequired || planningBlock.depotInFrom === scope.formatDateForApi()) {
        return resolve(false);
      } else {
        scope.sharedService.updateDepotInDate(planningBlock.id, scope.formatDateForApi(), userId)
          .subscribe(() => {
            planningBlock.depotInFrom = scope.formatDateForApi();
            return resolve(true);
          }, _ => {
            scope.userFeedbackService.showErrorMessage("TOASTR_MESSAGES.ERROR.DEPOT_IN_DATE_ERROR");
            scope.loading = false;
            return resolve(false);
          });
      }
    });
  }


  private updateContainerNumber(planningBlock: PlanningBlock, isMoveContainerOutOfPool: boolean): Promise<boolean> {
    const scope = this;
    return new Promise<boolean>((resolve) => {
      if (!scope.containerNumberRequired || planningBlock.containerNo === scope.containerNumber) {
        return resolve(false);
      } else {
        scope.sharedService.updateContainerNumber(planningBlock.id, scope.containerNumber, this.userId)
          .subscribe(() => {
            planningBlock.containerNo = scope.containerNumber;
            if (isMoveContainerOutOfPool) {
              return this.takeContainerFromPool();
            } else {
              this.containerIsAvailable = false;

              return resolve(true);
            }
          }, (err) => {
            scope.userFeedbackService.showErrorMessage("TOASTR_MESSAGES.ERROR.CONTAINER_NUMBER_ERROR");
            scope.loading = false;
            this.containerIsAvailable = false;

            return resolve(false);
          });
      }
    });
  }

  private takeContainerFromPool(): Promise<boolean> {
    const scope = this;
    return new Promise<boolean>((resolve) => {
      scope.homeService.getAuthorizedUser().subscribe((authorizedUser: AuthorizedUser) => {
        const statusPlanningBlock = scope.depotInSelection.length > 0 ?
          scope.depotInSelection[0] : scope.depotOutSelection[0];

        scope.poolService
          .takeContainerFromPool([statusPlanningBlock.id],
            authorizedUser.username, scope.containerNumber)
          .subscribe(() => {
            scope.buttonState = true;
            scope.containerIsAvailable = false;

            return resolve(true);
          },
            (err) => {
              scope.containerIsAvailable = false;
              scope.resetContainerNumber();

              return resolve(false);
            });
      });
    });
  }

  private updatePlanningBlocks(planningBlocks: PlanningBlock[], userId: string): Promise<boolean> {
    
    const scope = this;
    
    return new Promise<boolean>((resolve) => {
      let status: any;

      if (!scope.statusEnabled && !scope.locationSelector.locationchanged) {
        return resolve(false);
      }

      let updateContainerStatusModels: UpdateContainerStatusModel[] = []; 
      planningBlocks.forEach(planningBlock => {
        if (scope.statusEnabled) {
          status = scope.selectedStatus?.name;
        } else {
          status = planningBlock.containerStatus;
        }

        var addressId ='', location ='';
         if (scope.selectedLocation && scope.selectedLocation.addressId) {
            addressId = scope.selectedLocation.addressId;
          }

         if (scope.selectedLocation && scope.selectedLocation.addressId) {
            location = scope.selectedLocation.locationCode;
          } 
        
        if (scope.selectedStatus?.name !== planningBlock.containerStatus || scope.locationSelector.locationchanged) { 
          updateContainerStatusModels.push({
            planningBlockId: planningBlock.id,
            status: status, 
            addressLocation :{
              addressId: addressId, 
              locationCode: location, 
              location: "" 
            } ,
            userId: userId
          } );
        }
      });

      if(updateContainerStatusModels.length > 0) {
         
        scope.sharedService.updateBulkPlanningBlocksStatus(updateContainerStatusModels)
          .subscribe((returnedPbs) => {
            scope.userFeedbackService.showInfoMessage("TOASTR_MESSAGES.SUCCESS.STATUS_UPDATE_SUCCEEDED");
            this.sharedActions.updatePlanningBlocksDisplayCpl(returnedPbs);
            return resolve(true);
          }, (err) => {
            scope.loading = false;
            scope.userFeedbackService.showErrorMessage("TOASTR_MESSAGES.ERROR.STATUS_LOCATION_ERROR");
            return resolve(false);
          });
        }
       else {
        return resolve(false);
      }
    });
  }

  private formatDateForApi() {
    const dateArray = this.depotInFrom.split("-");
    const apiFormattedDate = dateArray[1] + "-" + dateArray[2] + "-" + dateArray[0];
    return apiFormattedDate;
  }

  public notifyReuse() {
    const selection: PlanningBlock[] = [...this.depotInSelection, ...this.depotOutSelection];
    if (selection.length === 1) {
      this.userFeedbackService.showWarningMessage(
        "REUSE_OPERATION_POSSIBLE_ON_SELECTED_PB",
        {
          orderNumber: selection[0].orderNumber,
          fileId: selection[0].fileId,
          containerNo: selection[0].containerNo,
          containerOrTrailerType: selection[0].containerOrTrailerType,
          carrierId: selection[0].carrierId
        },
        undefined,
        {
          closeButton: true,
          enableHtml: true,
          tapToDismiss: false
        }
      );
    }

    if ([...this.depotInSelection, ...this.depotOutSelection].length > 1) {
      this.depotInSelection.forEach((depotIn, index) => {
        this.userFeedbackService.showWarningMessage(
          "REUSE_OPERATION_POSSIBLE_ON_SELECTED_PB_PAIR",
          {
            depotInSelectionOrderNumber: depotIn.orderNumber,
            depotOutSelectionOrderNumber: this.depotOutSelection[index].orderNumber,
            depotInFileId: depotIn.fileId,
            depotOutSelectionFileId: this.depotOutSelection[index].fileId,
            depotInContainerNo: depotIn.containerNo,
            depotOutSelectionContainerNo: this.depotOutSelection[index].containerNo,
            depotInContainerOrTrailerType: depotIn.containerOrTrailerType,
            depotOutSelectionContainerOrTrailerType: this.depotOutSelection[index].containerOrTrailerType,
            depotInCarrierId: depotIn.carrierId,
            depotOutSelectionCarrierId: this.depotOutSelection[index].carrierId
          },
          undefined,
          {
            closeButton: true,
            enableHtml: true,
            tapToDismiss: false
          }
        );
      });
    }
    this.reuseNotified = true;
  }


  public comparePlanDateToDepotOutFrom(element){
    if (element.depotOutFrom === "" || element.depotOutFrom === null || element.depotOutFrom === undefined ) {
      return true;

    }
    var depotOutFrom = moment(element.depotOutFrom);
    if(depotOutFrom.isValid() === false){
      return true;
    }
    return moment(this.planDate).isSameOrAfter(depotOutFrom.startOf('day'));
  }

  public comparePlanDateToDepotInFrom(element) {
    if (element.depotInFrom === "" || element.depotInFrom === null || element.depotInFrom === undefined) {
      return true;

    }
    var depotInFrom = moment(element.depotInFrom)
   
    if(depotInFrom.isValid() === false){
      return true;
    }
   
    return moment(this.planDate).isSameOrAfter(depotInFrom.startOf('day'));
  }

  isLinkToAppointmentEnabled() {
    if (environment.tarTasEnabled) {
      if (!this.selectedPlanningBlocks) {
        this.selectedPlanningBlocks = [];
      }
      var result = this.tarTasManager.isLinkToAppointmentEnabled(this.selectedPlanningBlocks.filter(pb => pb.dInOrderLineID),
        this.selectedPlanningBlocks.filter(pb => pb.dOutOrderLineID));
      this.linkToAppointmentEnabled = result.linkToAppointmentEnabled;
      this.warningMessage = result.warningMessage;
      this.showWarning = result.showWarning;
    }
  }

  link() {
    this.linkToAppointmentEnabled = false;
    this.tarTasManager.linkDepotOutToDepotIn(this.selectedPlanningBlocks.filter(pb => pb.dInOrderLineID),
      this.selectedPlanningBlocks.filter(pb => pb.dOutOrderLineID));
  }

  public getSelectedDriver(driver: Driver) {
    this.selectedDriver = driver;
  }

  private getTextMessageAfterSucceededPlan(transportOrderNumber: string, depotInPlanningBlockIds: number[],
    depotOutPlanningBlockIds: number[]): any {
    this.smsService.getTextMessage(transportOrderNumber, depotInPlanningBlockIds,
      depotOutPlanningBlockIds,
    ).subscribe((sms: Sms) => {
      this.depotInSmsMessage = sms.depotInTextMessage;
      this.depotOutSmsMessage = sms.depotOutTextMessage;
      this.transportOrderNumber = transportOrderNumber;
      this.depotInPlanningBlockIdsForTextMessage = depotInPlanningBlockIds;
      this.depotOutPlanningBlockIdsForTextMessage = depotOutPlanningBlockIds;

      this.planAndSendSucceeded = true;
      this.loading = false;

    }, (error) => {
      this.userFeedbackService.showErrorMessage("ERROR : " + error.json().feedback[0].description);
      this.closeModal();
    });
  }


  public selectOpenTo(selectedTransportOrder, toRowIndex) {
    if (toRowIndex !== this.toRowIndex) {
      this.selectedTransportOrder = selectedTransportOrder;
      this.toRowIndex = toRowIndex;
    } else {
      this.selectedTransportOrder = null;
      this.toRowIndex = null;
    }
  }

  public closeToPanel() {
    this.openTransportOrdersForCapacity = [];
    this.openTransportOrdersForHaulier = [];
    this.toRowIndex = null;
  }

  public updateTransportOrderSelection(transportOrder: TransportOrder) {
    if (transportOrder) {
      this.selectedTransportOrder = transportOrder;
      this.selectedPlanningBlocks = null;
      this.planningDateNotCompatibleWarning =false  ; 
    }
  }

  public updatePlanningBlockSelection(planningBlock: PlanningBlock) {
    if (planningBlock) {
      //this.selectedPlanningBlocks = planningBlock;
      this.selectedTransportOrder = null;
    }
  }


  public resetTOSelection() {
    this.selectedTransportOrder = null;
  }

  public createNewTOFromModal() {
    this.selectedTransportOrder = null;
    this.closeToPanel();
  }
  public planExistingTo() {
    this.backToPreviousScreen();
    this.setSelectedCapacityFromTO();
    this.closeToPanel();
  }
  public setSelectedCapacityFromTO() {
    const selectedTransportOrderTruckNo = this.selectedTransportOrder.truck.id;
    // let filteredCapacities = this.capacit.filter((capacity) => {
    //     return capacity.truck.id === selectedTransportOrderTruckNo;
    // });
    // if (filteredCapacities.length > 0) {
    //     this.selectedCapacity = filteredCapacities[0];
    // }
  }

  public backToPreviousScreen() {
    if (this.masterDetailView) {
      this.masterDetailView = false;
    }
  }
  public checkDatesCompatiblity(): boolean {
    const defaultPlanDate = moment.utc(this.planDate).local();
    return !this.checkDateCompatibilityService.forPlanningOnSingleDate(defaultPlanDate, this.selectedPlanningBlocks);
  }


  public confirmChangePlanningBlockDate() {
    this.planningDateNotCompatibleWarning = false;
    this.planningFunctionCallback(true);

  }

  public ignorePlanningBlockDateChange() {
    this.planningDateNotCompatibleWarning = false;
    this.planningFunctionCallback(false);


  }
  public getPlanDateFormmatted() {
    return moment(this.planDate).format("yyyy-MM-DD");
  }

    public prettifyDate(d) {
      var navisionNullDate = moment("1760-01-01");
      if (typeof d === "string" || d instanceof String) {
        return moment(d.toString()) > navisionNullDate ? moment(d.toString()).format("DD-MM-YY HH:mm") : "";
      }
  
      if (moment.isMoment(d)) {
        d.local();
        var returnValue = d > navisionNullDate ? d.format("DD-MM-YY HH:mm") : "";
        d.utc();
        return returnValue;
      }
  
      return d;
    }

}


export interface DepotPlanningModalInput {
  source: string;
  PlanningModalSuccessed: Function;
}
function validateConditionsForSendingSMS(groupedData: TransportOrderPlanUnit, dataLoad: CreateTransportOrder): boolean {

  var allowedContainerPlanningField = [1, 2, 4]; //Container Planning Field in TMS Planning block card = Depot Out Container / Depot In Container or Depot Out / Depot in -Container. 

  var conainterPlanningFieldMatched = false;
  var planningGroupMatched = false;

  groupedData.depotInPlanningBlocks.forEach(pb => {
    if (allowedContainerPlanningField.lastIndexOf(pb.containerPlanningType) > -1) {
      conainterPlanningFieldMatched = true;
    }
    if (pb.planningGroup == "GATE") {
      planningGroupMatched = true;
    }
    else
      planningGroupMatched = false;

  });
  groupedData.depotOutPlanningBlocks.forEach(pb => {
    if (allowedContainerPlanningField.lastIndexOf(pb.containerPlanningType) > -1) {
      conainterPlanningFieldMatched = true;
    }
    if (pb.planningGroup == "GATE") {
      planningGroupMatched = true;
    }
  });

  if (conainterPlanningFieldMatched && planningGroupMatched) {
    return true;
  } else {
    return false;
  }

}


